// eslint-disable-next-line simple-import-sort/imports
import { ActionHandleEventType } from '@lighthouse/core'
import {
    ActionDataNodeType,
    EndNodeType,
    FlowControlNodeType,
    NoticeNodeType,
    OperatorNodeType,
    OtherPlatformNodeType
} from '@lighthouse/shared'
import { handleAliyunMessage, handleAliyunMessageStream } from './handlers/aliyunMessage'
import { handleCall, handleCallStream } from './handlers/call'
import { handleCloseFloat } from './handlers/closeFloat'
import { handleCondition } from './handlers/condition'
import { handleControlList } from './handlers/control'
import { handleCopy, handleCopyStream } from './handlers/copy'
import { handleCreateRecord, handleCreateRecordStream } from './handlers/createRecord'
import { handleDeleteRecord, handleDeleteRecordStream } from './handlers/deleteRecord'
import { handleDingTalkRobot } from './handlers/dingTalkRobot'
import { handleDownloadFile, handleDownloadFileStream } from './handlers/downloadFile'
import { handleEndStream } from './handlers/end'
import { handleFindSingleRecord } from './handlers/findSingleRecord'
import { handleGoBack } from './handlers/goBack'
import { handleOpenWechatCustomerService, handleOpenWechatCustomerServiceStream } from './handlers/handleOpenWechatCustomerService'
import { handleSubProcess } from './handlers/handleSubProcess'
import { handleNavigateToMiniProgram, handleNavigateToMiniProgramStream } from './handlers/navigateToMiniProgram'
import { handleNotification, handleNotificationStream } from './handlers/notification'
import { handleOpenLink, handleOpenLinkStream } from './handlers/openLink'
import { handleOpenPage, handleOpenPageStream } from './handlers/openPage'
import { handleOpenWechatLocation } from './handlers/openWechatLocation'
import { handleRefreshPage } from './handlers/refreshPage'
import { handleRefreshUserPermissions } from './handlers/refreshUserPermissions'
import { handleScreenShotList } from './handlers/screenShot'
import { handleScrollToList } from './handlers/scrollTo'
import { handleSendEmail } from './handlers/sendEmail'
import { sendMiniProgramSubscriptionMsg, sendMiniProgramSubscriptionMsgStream } from './handlers/sendMiniProgramSubscriptionMsg'
import { handleStationMessage } from './handlers/stationMessage'
import { handleStripePay } from './handlers/stripe'
import { subscriptionMiniProgramMsg } from './handlers/subscriptionMiniProgramMsg'
import { handleUpdatePageStateList } from './handlers/updatePageState'
import { updatePageShare } from './handlers/updatePageShare'
import { handleUpdateQueryParameterList } from './handlers/updateQueryParameter'
import { handleUpdateRecord, handleUpdateRecordStream } from './handlers/updateRecord'
import { handleWechatPay } from './handlers/wechatpay'
import { handleWechatTemplateMsg, handleWechatTemplateMsgStream } from './handlers/wechatTemplateMsg'
import { handleWxRobot } from './handlers/wxRobot'
import { handleAction } from './handlers/action'
import { handleAutomation } from './handlers/automation'
import { handleOpenWechatAudioPlayer } from './handlers/openWechatAudioPlayer'
import { handleOpenWechatChannelsActivity } from './handlers/handleOpenWechatChannelsActivity'

type NodeHandlerType =
    | Exclude<ActionDataNodeType, 'CREATE_RECORD_ACTION' | 'FIND_RECORD_ACTION' | 'IMPORT_EXCEL' | 'BATCH_IMPORT_FILE'>
    | Exclude<
          OtherPlatformNodeType,
          | 'GOOGLE_SEARCH_ACTION'
          | 'BAIDU_SEARCH_ACTION'
          | 'BING_SEARCH_ACTION'
          | 'WECHAT_REFUND'
          | 'WECHAT_REFUND_QUERY'
          | 'WECHAT_PROFIT_SHARING'
          | 'WECHAT_PROFIT_SHARING_QUERY'
          | 'WECHAT_PROFIT_SHARING_QUERY_AMOUNT'
          | 'WECHAT_ADD_RECEIVER'
          | 'WECHAT_DELETE_RECEIVER'
          | 'WECHAT_GENERATE_MINIPROGRAM_CODE'
          | 'WECHAT_UPLOAD_SHIPPING_INFO'
          | 'WECHAT_GET_ORDER_SHIPPING'
          | 'WECHAT_GET_ORDER_LIST'
          | 'WECHAT_FOLLOW_WAYBILL'
      >
    | OperatorNodeType
    | Exclude<FlowControlNodeType, 'LOOP_ACTION' | 'SEND_WEBSOCKET'>
    | NoticeNodeType
    | EndNodeType

export const nodeHandlers: Record<NodeHandlerType, Function> = {
    ALIYUN_MESSAGE_ACTION: handleAliyunMessageStream,
    CALL: handleCallStream,
    CLOSE_FLOAT: handleCloseFloat,
    CONDITION: handleCondition,
    COPY: handleCopyStream,
    CREATE_SINGLE_RECORD_ACTION: handleCreateRecordStream,
    DELETE_RECORD: handleDeleteRecordStream,
    DINGTALK_ROBOT_ACTION: handleDingTalkRobot,
    DOWNLOAD_FILE: handleDownloadFileStream,
    FIND_SINGLE_RECORD_ACTION: handleFindSingleRecord,
    GO_BACK: handleGoBack,
    HANDLE_SUB_PROCESS: handleSubProcess,
    NOTIFICATION: handleNotificationStream,
    OPEN_LINK: handleOpenLinkStream,
    OPEN_PAGE: handleOpenPageStream,
    REFRESH_PAGE: handleRefreshPage,
    REFRESH_USER_PERMISSIONS: handleRefreshUserPermissions,
    SEND_EMAIL_ACTION: handleSendEmail,
    STATION_MESSAGE_ACTION: handleStationMessage,
    STRIPE: handleStripePay,
    UPDATE_RECORD_ACTION: handleUpdateRecordStream,
    WECHAT_PAY: handleWechatPay,
    WECHAT_TEMPLATE_MSG_ACTION: handleWechatTemplateMsgStream,
    WX_ROBOT_ACTION: handleWxRobot,
    WECHAT_SUBSCRIPTION_MSG_ACTION: subscriptionMiniProgramMsg,
    WECHAT_SUBSCRIPTION_MSG_NOTIFICATION_ACTION: sendMiniProgramSubscriptionMsgStream,
    WECHAT_OPEN_LOCATION_ACTION: handleOpenWechatLocation,
    WECHAT_NAVIGATE_TO_MINI_PROGRAM: handleNavigateToMiniProgramStream,
    WECHAT_OPEN_CHANNELS_ACTIVITY: handleOpenWechatChannelsActivity,
    WECHAT_OPEN_AUDIO_PLAYER: handleOpenWechatAudioPlayer,
    OPEN_WECHAT_CUSTOMER_SERVICE: handleOpenWechatCustomerServiceStream,
    END: handleEndStream
}

export const actionHandlers: Record<ActionHandleEventType, Function> = {
    [ActionHandleEventType.ACTION]: handleAction,
    [ActionHandleEventType.AUTOMATION]: handleAutomation,
    [ActionHandleEventType.OPEN_WECHAT_CUSTOMER_SERVICE]: handleOpenWechatCustomerService,
    [ActionHandleEventType.WECHAT_NAVIGATE_TO_MINI_PROGRAM]: handleNavigateToMiniProgram,
    [ActionHandleEventType.WECHAT_OPEN_CHANNELS_ACTIVITY]: handleOpenWechatChannelsActivity,
    [ActionHandleEventType.OPEN_PAGE]: handleOpenPage,
    [ActionHandleEventType.OPEN_LINK]: handleOpenLink,
    [ActionHandleEventType.NOTIFICATION]: handleNotification,
    [ActionHandleEventType.GO_BACK]: handleGoBack,
    [ActionHandleEventType.COPY]: handleCopy,
    [ActionHandleEventType.CREATE_RECORD]: handleCreateRecord,
    [ActionHandleEventType.UPDATE_RECORD]: handleUpdateRecord,
    [ActionHandleEventType.DELETE_RECORD]: handleDeleteRecord,
    [ActionHandleEventType.DOWNLOAD_FILE]: handleDownloadFile,
    [ActionHandleEventType.CALL]: handleCall,
    [ActionHandleEventType.WECHAT_PAY]: handleWechatPay,
    [ActionHandleEventType.WECHAT_TEMPLATE_MSG]: handleWechatTemplateMsg,
    [ActionHandleEventType.STRIPE]: handleStripePay,
    [ActionHandleEventType.REFRESH_PAGE]: handleRefreshPage,
    [ActionHandleEventType.ALIYUN_MESSAGE]: handleAliyunMessage,
    [ActionHandleEventType.SCROLL_TO]: handleScrollToList,
    [ActionHandleEventType.CONTROL]: handleControlList,
    [ActionHandleEventType.CLOSE_FLOAT]: handleCloseFloat,
    [ActionHandleEventType.UPDATE_PAGE_STATE]: handleUpdatePageStateList,
    [ActionHandleEventType.UPDATE_PAGE_SHARE]: updatePageShare,
    [ActionHandleEventType.UPDATE_QUERY_PARAMETER]: handleUpdateQueryParameterList,
    [ActionHandleEventType.SCREEN_SHOT]: handleScreenShotList,
    [ActionHandleEventType.WECHAT_SUBSCRIPTION_MSG]: subscriptionMiniProgramMsg,
    [ActionHandleEventType.WECHAT_SUBSCRIPTION_MSG_NOTIFICATION]: sendMiniProgramSubscriptionMsg
}
